export default __webpack_public_path__ + "905640281ee27e0c2f9b66e27bbcef3e.woff";